<div class="availability"
     [class.availability--open]="isOpen">
  <button type="button"
          (click)="onToggle()"
          class="btn btn-orange availability__toggle availability__toggle--machine">
    <i class="fa fa-chevron-{{isOpen ? 'down' : 'up'}} mr-3"></i>
    <span class="font-weight-bold">Dostupnost mašina</span>
  </button>
  <div [class.container]="singleOrder">
    <div [class.row]="singleOrder">
      <div [class.col-10]="singleOrder" [class.offset-2]="singleOrder">
        <div class="row no-gutters mt-2">
          <div class="order-item">
            <div class="order-item__title">Ukupno minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="font-weight-bold font-14"
                       [class.text-red]="shift.timePlannedMachine > shift.totalAvailableTime">
                    {{ shift.totalAvailableTime | digitFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutters mt-2">
          <div class="order-item">
            <div class="order-item__title">Planirano minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="font-weight-bold font-14"
                       [class.text-red]="shift.timePlannedMachine > shift.totalAvailableTime">
                    {{ shift.timePlannedMachine | digitFormat }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutters mt-2">
          <div class="order-item">
            <div class="order-item__title">Preostalo minuta</div>
          </div>

          <div class="col" *ngFor="let day of availability; trackBy: trackByFn">
            <div class="day">
              <div class="day__shifts">
                <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn">
                  <div class="font-weight-bold font-14"
                       [class.text-green]="shift.timePlannedMachine < shift.totalAvailableTime"
                       [class.text-red]="shift.timePlannedMachine > shift.totalAvailableTime">
                    {{ (shift.totalAvailableTime?.toFixed() - shift.timePlannedMachine?.toFixed()) | digitFormat }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
